module.exports = __webpack_public_path__ + "static/logrocket-ae690648ae8cd19e8b861bce171e6b81.png";